// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { gql } from '@apollo/client';
export type AskDocumentQuestion_FileParagraphFragment = { __typename?: 'FileParagraph', id: string, content: string, file?: { __typename?: 'File', id: string, pdfDocument?: { __typename?: 'Document', id: string } | null } | null, boundingRegions: Array<{ __typename?: 'BoundingRegion', PageNumber: number, Polygon: Array<{ __typename?: 'Coordinate', x: number, y: number }> }> };

export type AskDocumentQuestion_MessageFragment = { __typename?: 'Message', id: string, role: Types.MessageRole, content: string, fileParagraphs?: Array<(
    { __typename?: 'FileParagraph' }
    & AskDocumentQuestion_FileParagraphFragment
  )> | null };

export type AskDocumentQuestion_ConversationFragment = { __typename?: 'Conversation', id: string, messages: { __typename?: 'MessageConnection', edges?: Array<{ __typename?: 'MessageEdge', node?: (
        { __typename?: 'Message' }
        & AskDocumentQuestion_MessageFragment
      ) | null } | null> | null } };

export const Operations = {
  Fragment: {
    AskDocumentQuestion_FileParagraph: 'AskDocumentQuestion_FileParagraph' as const,
    AskDocumentQuestion_Message: 'AskDocumentQuestion_Message' as const,
    AskDocumentQuestion_Conversation: 'AskDocumentQuestion_Conversation' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const AskDocumentQuestion_FileParagraphFragmentDoc = gql`
    fragment AskDocumentQuestion_FileParagraph on FileParagraph {
  id
  content
  file {
    id
    pdfDocument {
      id
    }
  }
  boundingRegions {
    PageNumber
    Polygon {
      x
      y
    }
  }
}
    `;
export const AskDocumentQuestion_MessageFragmentDoc = gql`
    fragment AskDocumentQuestion_Message on Message {
  id
  role
  content
  fileParagraphs {
    ...AskDocumentQuestion_FileParagraph
  }
}
    ${AskDocumentQuestion_FileParagraphFragmentDoc}`;
export const AskDocumentQuestion_ConversationFragmentDoc = gql`
    fragment AskDocumentQuestion_Conversation on Conversation {
  id
  messages {
    edges {
      node {
        ...AskDocumentQuestion_Message
      }
    }
  }
}
    ${AskDocumentQuestion_MessageFragmentDoc}`;